"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _lodash = _interopRequireDefault(require("lodash.get")),
    _hls = _interopRequireDefault(require("hls.js")),
    _createHlsStream = _interopRequireDefault(require("@devsta/create-hls-stream")),
    _FileTypeIcon = _interopRequireDefault(require("../../FileTypeIcon")),
    _InteractiveOverlay = _interopRequireDefault(require("../../InteractiveOverlay")),
    _getVideoThumbnail = _interopRequireDefault(require("../utils/getVideoThumbnail")),
    _ImagePreview = _interopRequireDefault(require("../../ImagePreview/components/ImagePreview")),
    _fileTypes = require("../../../../../common/constants/fileTypes");

require("../styles/_video-preview.scss");

var _utils = require("../../../../../common/utils"),
    _getDarkModeImageProps = _interopRequireDefault(require("../../../utils/getDarkModeImageProps"));

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var ASSET_POLL_FREQUENCY = 5e3;

function getVideoId(_ref) {
  var assetId = _ref.assetId;
  return "video-preview-".concat(assetId);
}

function hasTranscodedVideoFiles(asset) {
  var assetFiles = (asset || {}).assetFiles;
  return assetFiles && assetFiles.HD && assetFiles.SD && assetFiles.STREAM;
}

function handleRightClick(e) {
  e.preventDefault(), e.stopPropagation();
}

function getSourceFile(asset) {
  var assetFiles = (asset || {}).assetFiles;
  return assetFiles ? _hls["default"].isSupported() && assetFiles.STREAM && assetFiles.STREAM.fragments.length ? assetFiles.STREAM : assetFiles.SD || {} : {};
}

function getThumbnail(asset) {
  var assetFiles = (asset || {}).assetFiles;
  return assetFiles && assetFiles.THUMBNAIL;
}

var VideoPreview = function (_Component) {
  function VideoPreview() {
    var _this;

    return (0, _classCallCheck2["default"])(this, VideoPreview), _this = _super.call(this), _this.componentWillUnmount = function () {
      _this._videoRef && (_this._videoRef.removeEventListener("contextmenu", handleRightClick), _this._videoRef = null), _this._assetPollInterval && clearInterval(_this._assetPollInterval);
    }, _this.handleAssetPoll = function () {
      var _this$props = _this.props,
          fetchAssets = _this$props.fetchAssets,
          assetId = _this$props.assetId;
      _this._assetPollInterval = setInterval(function () {
        var latestAsset = _this.props.asset;
        return hasTranscodedVideoFiles(latestAsset) ? (clearInterval(_this._assetPollInterval), void (_this._assetPollInterval = null)) : void fetchAssets({
          assetId: assetId
        });
      }, ASSET_POLL_FREQUENCY);
    }, _this.onVideoReady = function () {
      _this.setState({
        buffering: !1
      });
    }, _this.setVideoRef = function (videoRef) {
      videoRef && (_this._videoRef = videoRef, videoRef.addEventListener("contextmenu", handleRightClick), videoRef.addEventListener("loadeddata", _this.onVideoReady));
    }, _this.toggleVideoPlay = function () {
      var asset = _this.props.asset,
          _this$state = _this.state,
          playing = _this$state.playing,
          startTime = _this$state.startTime;
      playing && _this._videoRef && _this._videoRef.pause();
      var thumbnail = playing ? (0, _getVideoThumbnail["default"])("#".concat(getVideoId(asset))) : void 0,
          newStartTime = _this._videoRef && playing ? _this._videoRef.currentTime : startTime;

      _this.setState(function (_ref5) {
        var currentPlaying = _ref5.playing;
        return {
          playing: !currentPlaying,
          overrideThumbnail: thumbnail,
          startTime: newStartTime,
          buffering: !currentPlaying
        };
      }, _this.toggleVideoPlaySetStateCallback);
    }, _this.toggleVideoPlaySetStateCallback = function () {
      var videoRef = _this._videoRef,
          asset = _this.props.asset,
          _getSourceFile = getSourceFile(asset),
          type = _getSourceFile.type,
          sourceUrl = _getSourceFile.sourceUrl,
          fragments = _getSourceFile.fragments,
          _this$state2 = _this.state,
          latestPlaying = _this$state2.playing,
          startTime = _this$state2.startTime;

      return videoRef && latestPlaying ? _hls["default"].isSupported() && "STREAM" === type ? void (_this._httpLiveStream = (0, _createHlsStream["default"])(fragments, startTime, -1, sourceUrl, videoRef), _this._httpLiveStream.on(_hls["default"].Events.MANIFEST_PARSED, function () {
        return (0, _utils.attemptToPlayVideo)(videoRef);
      })) : void (0, _utils.attemptToPlayVideo)(videoRef) : void 0;
    }, _this.restartPreview = function () {
      _this._videoRef && (_this._videoRef.currentTime = 0, _this.setState({
        playing: !1,
        overrideThumbnail: void 0,
        startTime: 0
      }));
    }, _this.getCurrentTime = function () {
      return _this._videoRef ? _this._videoRef.currentTime : 0;
    }, _this.state = {
      playing: !1,
      buffering: !1,
      startTime: 0
    }, _this;
  }

  (0, _inherits2["default"])(VideoPreview, _Component);

  var _super = _createSuper(VideoPreview);

  return (0, _createClass2["default"])(VideoPreview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleAssetPoll();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$props2 = this.props,
          asset = _this$props2.asset,
          hideFileTypeIcon = _this$props2.hideFileTypeIcon,
          darkMode = _this$props2.darkMode,
          canPlayVideo = _this$props2.canPlayVideo,
          _this$state3 = this.state,
          playing = _this$state3.playing,
          buffering = _this$state3.buffering,
          startTime = _this$state3.startTime,
          overrideThumbnail = _this$state3.overrideThumbnail,
          _getSourceFile2 = getSourceFile(asset),
          sourceUrl = _getSourceFile2.sourceUrl,
          isTranscoding = !(0, _lodash["default"])(asset, "assetFiles.SD"),
          originalThumbnail = getThumbnail(asset),
          colourMap = (0, _getDarkModeImageProps["default"])({
        darkMode: darkMode
      });

      return isTranscoding ? _react["default"].createElement(_ImagePreview["default"], {
        hideFileTypeIcon: !0,
        type: _fileTypes.VIDEO,
        imageProps: {
          defaultImageIcon: "rushedit",
          defaultIconBackground: colourMap.background,
          defaultIconColour: colourMap.icon,
          defaultIconSize: 40,
          defaultIconSubtitle: "Preparing"
        }
      }) : canPlayVideo ? _react["default"].createElement(_InteractiveOverlay["default"], {
        onPlay: this.toggleVideoPlay,
        onPause: this.toggleVideoPlay,
        onRestart: this.restartPreview,
        playing: playing,
        getCurrentTime: this.getCurrentTime,
        loading: buffering
      }, function (_ref6) {
        var overlay = _ref6.overlay,
            hovering = _ref6.hovering,
            onMouseOver = _ref6.onMouseOver,
            onMouseLeave = _ref6.onMouseLeave;
        return _react["default"].createElement("div", {
          className: "video-preview",
          onMouseOver: onMouseOver,
          onMouseLeave: onMouseLeave,
          onDragStart: onMouseLeave,
          onFocus: onMouseOver,
          onBlur: onMouseLeave,
          role: "button",
          tabIndex: 0
        }, overlay, hideFileTypeIcon || playing && !hovering ? null : _react["default"].createElement(_FileTypeIcon["default"], {
          name: "projects"
        }), playing ? _react["default"].createElement("video", {
          crossOrigin: "anonymous",
          id: getVideoId(asset),
          autoPlay: !0,
          ref: _this2.setVideoRef,
          className: "video-preview__video",
          src: sourceUrl && "".concat(sourceUrl).concat(startTime ? "#t=".concat(startTime) : "")
        }) : _react["default"].createElement(_uiKit.Image, {
          defaultImageIcon: "projects",
          imageUrl: overrideThumbnail || originalThumbnail && originalThumbnail.sourceUrl,
          height: "100%",
          width: "100%",
          default: !0
        }));
      }) : _react["default"].createElement(_ImagePreview["default"], {
        asset: asset,
        type: _fileTypes.VIDEO,
        hideFileTypeIcon: hideFileTypeIcon,
        darkMode: darkMode
      });
    }
  }]), VideoPreview;
}(_react.Component);

exports["default"] = VideoPreview;